export const BRAND_IMAGE_MAP: Record<string, string> = {
  visa: "visa",
  mastercard: "mastercard",
  american_express: "amex",
  amex: "amex",
  discover: "discover",
  diners: "diners",
  diners_club: "diners",
  jcb: "jcb",
  unionpay: "unionpay",
};

/**
 * Returns the image src for a given card brand or null if none is known.
 * Normalizes spaces/underscores and case to match our asset filenames.
 */
export function getBrandImageSrc(brand: string | undefined | null): string | null {
  if (!brand) return null;
  const key = String(brand).toLowerCase().replace(/ /g, "_");
  const file = BRAND_IMAGE_MAP[key];
  return file ? `/images/creditcard/${file}.png` : null;
}
